// config4js.js
// secure_config4js.js - EXPERIMENT: 6.5.3 with 7.8 backend
const ziroProdUrl = 'https://zirostudio.appspot.com';
const ziroDevUrl = 'https://ziroaidev.appspot.com';
const ziro78StagingUrl = 'https://ziro-ai-staging.uc.r.appspot.com'; // 7.8 backend (App Engine)
const ziro78AuthUrl = 'https://auth-dot-ziro-ai-staging.uc.r.appspot.com'; // 7.8 auth service

const prodClientID = '63484626655-m8qob117c85supplbltigvgrv9vung43.apps.googleusercontent.com';
const devClientID = '1050770307315-6s4be5midit1kgft5clv237nkpukoc24.apps.googleusercontent.com';

// EXPERIMENT PAUSED: Back to production (7.8 vars kept for reference)
export const serverUrl = ziroProdUrl; // Production main.py → zirostudio.appspot.com
export const altServerUrl = ziroDevUrl;  // Production auth → ziroaidev.appspot.com
export const globalClientId = prodClientID;
export const exploreBackendUrl = ziroProdUrl; // Main API